//load all images
const images = require.context('./images', true)

// load all styles
import './css/application';

// init global user javascript
import './js/global/init.js';
